import React, { useRef, useState } from "react";
import { useUscSelector } from "../../../redux/store";
import { useUscLabel } from "../../../utils/labels";
import { useCloseOnOutsideClick } from "../../../../../common-deprecated/hooks";
import TaxLocationSearch from "./TaxLocationSearch";
import { getLocationId } from "../../../utils/externalPriceUtils";
import Label from "../styles/atoms/Label";
import Text from "../../../../shared-components/toyota/styles/atoms/Text";
import Selectlist from "../styles/molecules/Selectlist";
import type { UscTrackingLocation } from "../../../utils/tracking";
import * as Styles from "./TaxLocation.styles";

type TaxLocationPropsType = {
    trackingLocation: UscTrackingLocation;
    // This component gets shown in two places:
    // 1. In the basket, where we hide the dropdown and instead show the selected location
    //    as well as slightly changing the styling
    // 2. On the configuration page, where the user is able to select a location
    //    from a dropdown
    inBasket?: boolean;
};

const TaxLocation = ({ trackingLocation, inBasket }: TaxLocationPropsType): JSX.Element | null => {
    const taxLocations = useUscSelector((state) => state.uscSettings.taxLocations);
    const currentTaxLocation = useUscSelector(({ uscSettings, externalPrice, dealer }) =>
        uscSettings.taxLocations.find(
            (location) => location.id === getLocationId(dealer.dealer, externalPrice.userTaxLocationId),
        ),
    );
    const [departmentLabel, regionLabel] = useUscLabel(["uscTaxesAndCostsDepartment", "uscTaxesAndCostsSelectRegion"]);

    const [regionsVisible, setRegionsVisible] = useState<boolean>(false);
    const dropdownRef = useRef<HTMLDivElement>(null);
    useCloseOnOutsideClick(dropdownRef, () => setRegionsVisible(false), !regionsVisible);

    // Only show Tax Location dropdown when country has tax locations
    if (!taxLocations.length) return null;

    return (
        <Styles.Wrapper inBasket={inBasket}>
            {inBasket ? (
                <>
                    <Text variant="body-small-regular">{departmentLabel}</Text>
                    <Text variant="body-small-book">{currentTaxLocation?.label}</Text>
                </>
            ) : (
                <>
                    <Label variant="form-label">{departmentLabel}</Label>
                    <Selectlist
                        name="select-tax-location"
                        variant="selectlist-with-search"
                        selectlistTitle={currentTaxLocation?.label}
                        listboxHeadingTitle={regionLabel}
                        show={regionsVisible}
                        dropdownRef={dropdownRef}
                        onClick={() => {
                            setRegionsVisible(!regionsVisible);
                        }}
                    >
                        <TaxLocationSearch
                            onClose={() => setRegionsVisible(false)}
                            trackingLocation={trackingLocation}
                        />
                    </Selectlist>
                </>
            )}
        </Styles.Wrapper>
    );
};

export default TaxLocation;
